import checkbox from "../asset/images/account/checkbox.png";
import Loader from "../component/loader";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import personal from "../asset/images/changepin.svg";
import { useSelector } from "react-redux";
import business from "../asset/images/resetpassword.svg";
import beneficiary from "../asset/images/Notification-alert.svg";
import SuccessHolder from "./SuccessHolder";
import FailHandler from "../component/failhandler";
import balance from "../asset/images/requeststatmement.svg";
import ConfirmPin from "./confirmModal";
import axios from "axios";
import { Mobile, Refresh2 } from "iconsax-reactjs";
import { copyField } from "../utilities/clipboard";
import BackupCodesModal from "../pages/auth_v2/2FA/BackupCodesModal";
import Confirm2FAModal from "../pages/auth_v2/signin/Confirm2FAModal";

const getBackupCodes = (data) => {
    if (Array.isArray(data?.backupCodes)) return data.backupCodes;
    if (Array.isArray(data?.backup_codes)) return data.backup_codes;
    if (Array.isArray(data?.recoveryCodes)) return data.recoveryCodes;
    if (Array.isArray(data?.recovery_codes)) return data.recovery_codes;
    if (Array.isArray(data?.codes)) return data.codes;
    return [];
};

const Security = () => {
    const [profiletab, setprofiletab] = useState(0);
    const toggledetail = [
        "Change PIN",
        "Reset password",
        "Two-factor authentication",
        "Notifications",
        // "Request statement",
    ];
    const [selectedtoggle, setselectedtoggle] = useState(0);
    const [message, setmessage] = useState("");
    const [password, setpassword] = useState("");
    const [currentpassword, setcurrentpassword] = useState("");

    const selector = useSelector((state) => state.users);
    const [pins, setPins] = useState(["", "", "", ""]);
    const [newpin, setNewPins] = useState("");

    const [loaderupdate, setloaderupdate] = useState(false);
    const [failhandler, setfailhandler] = useState(false);
    const selectorbusiness = useSelector((state) => state.business);
    const [successholder, setsuccessholder] = useState(false);
    const [show, setShow] = useState(false);
    const [loader, setloader] = useState(false);
    const [isPushednotificationupdate, setisPushednotificationupdate] = useState(false);
    const [isEmailupdate, setisEmailupdate] = useState(false);
    const [showRegenerateCodesModal, setShowRegenerateCodesModal] = useState(false);
    const [showResetAuthAppModal, setShowResetAuthAppModal] = useState(false);
    const [showBackupCodesModal, setShowBackupCodesModal] = useState(false);
    const [regeneratedBackupCodes, setRegeneratedBackupCodes] = useState([]);
    const [hasSavedBackupCodes, setHasSavedBackupCodes] = useState(false);
    const navigate = useNavigate();
    const isMfaEnabled = !!selector?.isMfaEnabled;

    const inputs = useRef([]);

    useEffect(() => {
        inputs.current[0]?.focus();
    }, []);
    useEffect(() => {
        if (successholder || failhandler) {
            let timer = setTimeout(() => {
                setfailhandler(false);
                setsuccessholder(false);
            }, 3000);
            return () => {
                clearTimeout(timer);
            };
        }
    });

    const handleInputChange = (event, index) => {
        const currentInput = event.target.value.trim();

        if (/^\d$/.test(currentInput)) {
            const newPins = [...pins];
            newPins[index] = currentInput;

            setPins(newPins);

            if (index < inputs.current.length - 1 && currentInput) {
                inputs.current[index + 1].focus();
            }
        }
    };

    const handleInputBackspace = (event, index) => {
        const currentInput = event.target.value.trim();
        console.log(currentInput);

        if (event.key === "Backspace" && !currentInput && index > 0) {
            const newPins = [...pins];
            newPins[index - 1] = "";

            setPins(newPins);
            inputs.current[index - 1].focus();
        }
    };
    const changePassword = async (e) => {
        e.preventDefault();

        setloader(true);
        const data = {
            password: password,
            newPassword: currentpassword,
        };
        axios
            .put("/v1/users/update-password", data)
            .then((res) => {
                setmessage(res.data.message);
                setsuccessholder(true);
                setloader(false);
                setpassword("");
                setcurrentpassword("");
            })
            .catch((e) => {
                setmessage(
                    e.response?.data?.message ? e.response?.data?.message : "An error Ocuur"
                );
                setsuccessholder(false);
                setfailhandler(true);
                setloader(false);
            });
    };
    const changeUpdate = async (e) => {
        // e.preventDefault();

        setloader(true);
        const data = {
            emailUpdate: isEmailupdate.toString(),
            pushNotification: isPushednotificationupdate.toString(),
        };
        axios
            .put("/v1/users/update-notification", data)
            .then((res) => {
                setmessage(res.data.message);
                setsuccessholder(true);
                setloader(false);
                setpassword("");
                setcurrentpassword("");
            })
            .catch((e) => {
                setmessage(
                    e.response?.data?.message ? e.response?.data?.message : "An error Ocurred"
                );
                setsuccessholder(false);
                setfailhandler(true);
                setloader(false);
            });
    };

    const sendRequest = async (e) => {
        e.preventDefault();
        setShow(false);
        setloader(true);
        // const [pin1, pin2, pin3, pin4] = pin;
        //   const numericPin = pin1 + "" + pin2 + "" + pin3 + "" + pin4;
        //const pinsdata = {
        //pin: numericPin,
        //};
        const [newpin1, newpin2, newpin3, newpin4] = pins;
        const allnewpin = newpin1 + "" + newpin2 + "" + newpin3 + "" + newpin4;
        const newpin = {
            pin: allnewpin,
            password: password,
        };

        await axios
            .post("/v1/users/reset-pin", newpin)
            .then((res) => {
                setmessage(res.data.message);
                setsuccessholder(true);
                setloader(false);
                setPins(["", "", "", ""]);
                setpassword("");
            })
            .catch((e) => {
                setmessage(
                    e.response?.data?.message ? e.response?.data?.message : "An error Ocurred"
                );
                setsuccessholder(false);
                setfailhandler(true);
                setloader(false);
            })

            .catch((e) => {
                setmessage(
                    e.response?.data?.message ? e.response?.data?.message : "An error Ocuur"
                );
                setsuccessholder(false);
                setfailhandler(true);
                setloader(false);
            });
    };

    const handleAuthenticatorToggle = () => {
        if (isMfaEnabled) return;
        navigate("/auth/setup-2fa");
    };

    const markBackupCodesAsSaved = () => {
        setHasSavedBackupCodes(true);
    };

    const handleCloseBackupCodesModal = () => {
        if (!hasSavedBackupCodes) return;

        setShowBackupCodesModal(false);
        setRegeneratedBackupCodes([]);
        setHasSavedBackupCodes(false);
    };

    const handleCopyBackupCodes = async () => {
        const copied = await copyField(regeneratedBackupCodes.join("\n"), "Backup codes");
        if (copied) {
            markBackupCodesAsSaved();
        }
    };

    const handleDownloadBackupCodes = () => {
        if (!regeneratedBackupCodes.length) return;

        const blob = new Blob([regeneratedBackupCodes.join("\n")], {
            type: "text/plain;charset=utf-8",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = "tradevu-backup-codes.txt";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        markBackupCodesAsSaved();
    };

    const handlePrintBackupCodes = () => {
        if (!regeneratedBackupCodes.length) return;

        const printWindow = window.open("", "_blank", "width=800,height=600");
        if (!printWindow) return;

        printWindow.document.write(`
            <html>
                <head>
                    <title>Tradevu Backup Codes</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 32px; color: #161827; }
                        h1 { font-size: 28px; margin-bottom: 12px; }
                        p { font-size: 16px; line-height: 1.6; }
                        ul { margin-top: 24px; columns: 2; padding-left: 20px; }
                        li { margin-bottom: 12px; font-size: 18px; }
                    </style>
                </head>
                <body>
                    <h1>Tradevu Backup Codes</h1>
                    <p>Keep these codes safe and do not share them. Each code can only be used once.</p>
                    <ul>${regeneratedBackupCodes.map((code) => `<li>${code}</li>`).join("")}</ul>
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        markBackupCodesAsSaved();
    };

    const handleRegenerateBackupCodes = async (mfaCode) => {
        const response = await axios.post("/v1/users/mfa-backup-regenerate", {
            mfaCode,
        });
        const data = response?.data?.data || response?.data || {};
        const codes = getBackupCodes(data);

        if (!codes.length) {
            throw new Error("Unable to load regenerated backup codes.");
        }

        setRegeneratedBackupCodes(codes);
        setHasSavedBackupCodes(false);
        setShowRegenerateCodesModal(false);
        setShowBackupCodesModal(true);
        setmessage(response?.data?.message || "Backup codes regenerated successfully.");
        setsuccessholder(true);
        setfailhandler(false);

        return data;
    };

    const handleResetAuthenticatorApp = async (mfaCode) => {
        const response = await axios.post("/v1/users/mfa-reset", {
            mfaCode,
        });
        const setupData = response?.data?.data || response?.data || {};

        setShowResetAuthAppModal(false);
        setmessage(response?.data?.message || "Two-factor authentication reset successfully.");
        setsuccessholder(true);
        setfailhandler(false);
        navigate("/auth/setup-2fa", {
            state: {
                setupData,
                source: "mfa-reset",
            },
        });

        return setupData;
    };
    return (
        <>
            <ConfirmPin
                pincode={pins}
                show={show}
                setshow={setShow}
                setPins={setNewPins}
                sendRequest={sendRequest}
            />
            <Confirm2FAModal
                isOpen={showRegenerateCodesModal}
                onClose={() => setShowRegenerateCodesModal(false)}
                onVerifyCode={handleRegenerateBackupCodes}
                title="Verify your identity"
                description="Enter the 6-digit code from your authenticator app to generate a fresh set of backup verification codes."
                submitLabel="Generate codes"
                emptyMessage="Please enter the 6-digit code from your authenticator app."
                errorFallback="Unable to generate new backup codes. Please try again."
            />
            <Confirm2FAModal
                isOpen={showResetAuthAppModal}
                onClose={() => setShowResetAuthAppModal(false)}
                onVerifyCode={handleResetAuthenticatorApp}
                title="Verify your identity"
                description="Enter the 6-digit code from your authenticator app to continue."
                submitLabel="Verify"
                emptyMessage="Please enter the 6-digit code from your authenticator app."
                errorFallback="Unable to reset your authenticator app. Please try again."
            />
            <BackupCodesModal
                isOpen={showBackupCodesModal}
                backupCodes={regeneratedBackupCodes}
                hasSavedBackupCodes={hasSavedBackupCodes}
                onClose={handleCloseBackupCodesModal}
                onCopy={handleCopyBackupCodes}
                onDownload={handleDownloadBackupCodes}
                onPrint={handlePrintBackupCodes}
                onRegenerate={() => {}}
            />
            <div
                className="p-0 card-body"
                style={{
                    borderRadius: "24px 24px 0px 0px",

                    minHeight: "977px",
                    display: "flex",
                    overflowY: "auto",
                }}
            >
                <div className="left-col-static-nav">
                    <div className="interrior-lg-sm">
                        {toggledetail.map((toggle, index) => (
                            <div
                                className="each-scale-ratio"
                                key={index}
                                style={{
                                    border: selectedtoggle === index && "0.5px solid #6F00FF",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    setselectedtoggle(index);

                                    setprofiletab(index);
                                }}
                            >
                                <div
                                    className="inner-lg-mf"
                                    style={{
                                        background: selectedtoggle === index && "#F4F0FF",
                                    }}
                                >
                                    <div className="img-lg-text">
                                        <img
                                            src={
                                                index === 0
                                                    ? personal
                                                    : index === 1
                                                      ? business
                                                      : index === 3
                                                        ? beneficiary
                                                        : balance
                                            }
                                            alt=""
                                        />
                                        <span>{toggle}</span>
                                    </div>
                                    {selectedtoggle === index && <img src={checkbox} alt="" />}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {profiletab === 0 && (
                    <form className="right-side-account-details" onSubmit={sendRequest}>
                        <div className="miid-side-details">
                            <SuccessHolder success={successholder} message={message} />
                            <FailHandler success={failhandler} message={message} />

                            <div
                                className="top-details-lg-mgph"
                                style={{
                                    gap: "32px",
                                }}
                            >
                                <div className="lower_layer_layout">
                                    <h2
                                        style={{
                                            padding: "0px",
                                            margin: "0px",
                                        }}
                                    >
                                        Change PIN
                                    </h2>
                                    <span>Please, enter your PIN</span>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "16px",
                                        maxWidth: "300px",
                                        width: "100%",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    {pins.map((pin, index) => (
                                        <input
                                            key={index}
                                            type="tel"
                                            className="!shadow-none"
                                            required
                                            style={{
                                                background: "#ECEFF3",
                                                color: "#667085",
                                                padding: "8px 16px 8px 16px",
                                                textAlign: "center",
                                                height: "53px",
                                                minWidth: "50px",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: "8px",
                                            }}
                                            placeholder="-"
                                            maxLength="1"
                                            value={pin}
                                            ref={(element) => (inputs.current[index] = element)}
                                            onChange={(event) => handleInputChange(event, index)}
                                            onKeyDown={(event) =>
                                                handleInputBackspace(event, index)
                                            }
                                        />
                                    ))}
                                </div>
                                <div
                                    className="each-profile-input"
                                    style={{
                                        maxWidth: "300px",
                                        width: "100%",
                                    }}
                                >
                                    <label htmlFor="">Password</label>
                                    <input
                                        type="password"
                                        value={password}
                                        required
                                        onChange={(e) => setpassword(e.target.value)}
                                        style={{
                                            width: "100%",
                                        }}
                                        placeholder="Enter password"
                                        className="!shadow-none"
                                    />
                                </div>

                                <button className="confirmButtonPin" type="subnit">
                                    {loader ? <Loader /> : "Confirm"}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
                {profiletab === 1 && (
                    <form className="right-side-account-details" onSubmit={changePassword}>
                        <div className="miid-side-details">
                            <SuccessHolder success={successholder} message={message} />
                            <FailHandler success={failhandler} message={message} />

                            <div
                                className="top-details-lg-mgph"
                                style={{
                                    gap: "32px",
                                }}
                            >
                                <div className="lower_layer_layout">
                                    <h2
                                        style={{
                                            padding: "0px",
                                            margin: "0px",
                                        }}
                                    >
                                        Change password
                                    </h2>
                                    <span>Enter a new password below</span>
                                </div>

                                <div
                                    className="each-profile-input"
                                    style={{
                                        maxWidth: "50%",
                                        width: "100%",
                                    }}
                                >
                                    <label htmlFor="">Current Password</label>
                                    <input
                                        type="password"
                                        value={currentpassword}
                                        onChange={(e) => setcurrentpassword(e.target.value)}
                                        style={{
                                            width: "100%",
                                        }}
                                        placeholder="Enter password"
                                        className="!shadow-none"
                                    />
                                </div>
                                <div
                                    className="each-profile-input"
                                    style={{
                                        maxWidth: "50%",
                                        width: "100%",
                                    }}
                                >
                                    <label htmlFor="">Password</label>
                                    <input
                                        type="password"
                                        value={password}
                                        onChange={(e) => setpassword(e.target.value)}
                                        style={{
                                            width: "100%",
                                        }}
                                        placeholder="Enter new password"
                                        className="!shadow-none"
                                    />
                                </div>

                                <button className="confirmButtonPin">
                                    {loader ? <Loader /> : "Change Password"}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
                {profiletab === 2 && (
                    <div className="right-side-account-details">
                        <div className="miid-side-details">
                            <SuccessHolder success={successholder} message={message} />
                            <FailHandler success={failhandler} message={message} />

                            <div
                                className="top-details-lg-mgph"
                                style={{
                                    gap: "32px",
                                }}
                            >
                                <div className="lower_layer_layout">
                                    <h2
                                        style={{
                                            padding: "0px",
                                            margin: "0px",
                                        }}
                                    >
                                        Two-factor authentication
                                    </h2>
                                    <span>
                                        Manage your authenticator app and backup recovery codes
                                    </span>
                                </div>

                                <div
                                    style={{
                                        width: "100%",
                                        maxWidth: "780px",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "24px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: "24px",
                                            flexWrap: "wrap",
                                            padding: "8px 0px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "12px",
                                            }}
                                        >
                                            <Mobile variant="Bulk" color="#6F739B" />
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "16px",
                                                        fontWeight: 500,
                                                        color: "#101828",
                                                    }}
                                                >
                                                    Authenticator app
                                                </span>
                                                <label
                                                    className="switch"
                                                    style={{
                                                        marginBottom: 0,
                                                        opacity: isMfaEnabled ? 0.65 : 1,
                                                        cursor: isMfaEnabled
                                                            ? "not-allowed"
                                                            : "pointer",
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={isMfaEnabled}
                                                        onChange={handleAuthenticatorToggle}
                                                        disabled={isMfaEnabled}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            onClick={() => {
                                                setShowResetAuthAppModal(true);
                                                setfailhandler(false);
                                                setsuccessholder(false);
                                            }}
                                            style={{
                                                minWidth: "228px",
                                                height: "52px",
                                                borderRadius: "12px",
                                                border: "1px solid #EAECF0",
                                                background: "#FFFFFF",
                                                color: "#101828",
                                                fontSize: "16px",
                                                fontWeight: 500,
                                            }}
                                        >
                                            Change auth app
                                        </button>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: "24px",
                                            flexWrap: "wrap",
                                            padding: "8px 0px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "12px",
                                            }}
                                        >
                                            <Mobile variant="Bulk" color="#6F739B" />
                                            <span
                                                style={{
                                                    fontSize: "16px",
                                                    fontWeight: 500,
                                                    color: "#101828",
                                                }}
                                            >
                                                Backup verification codes
                                            </span>
                                        </div>

                                        <button
                                            type="button"
                                            onClick={() => {
                                                setShowRegenerateCodesModal(true);
                                                setfailhandler(false);
                                                setsuccessholder(false);
                                            }}
                                            style={{
                                                minWidth: "288px",
                                                height: "52px",
                                                borderRadius: "12px",
                                                border: "1px solid #EAECF0",
                                                background: "#FFFFFF",
                                                color: "#101828",
                                                fontSize: "16px",
                                                fontWeight: 500,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "10px",
                                            }}
                                        >
                                            <Refresh2 />
                                            Generate new codes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {profiletab === 3 && (
                    <form className="right-side-account-details" onSubmit={changePassword}>
                        <div className="miid-side-details">
                            <SuccessHolder success={successholder} message={message} />
                            <FailHandler success={failhandler} message={message} />

                            <div
                                className="top-details-lg-mgph"
                                style={{
                                    gap: "32px",
                                }}
                            >
                                <div className="lower_layer_layout">
                                    <h2
                                        style={{
                                            padding: "0px",
                                            margin: "0px",
                                        }}
                                    >
                                        Notifications
                                    </h2>
                                    <span>Edit your notification preferences</span>
                                </div>

                                <div className="each_notify_col">
                                    <div className="main-each-layout">
                                        <span>Push notifications</span>
                                        <label class="switch">
                                            <input
                                                type="checkbox"
                                                checked={isPushednotificationupdate}
                                                onChange={() => {
                                                    changeUpdate();
                                                    setisPushednotificationupdate(
                                                        !isPushednotificationupdate
                                                    );
                                                }}
                                            />
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                    <div className="main-each-layout">
                                        <span>Email updates</span>
                                        <label class="switch">
                                            <input
                                                type="checkbox"
                                                checked={isEmailupdate}
                                                onChange={() => {
                                                    changeUpdate();
                                                    setisEmailupdate(!isEmailupdate);
                                                }}
                                            />
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </div>
        </>
    );
};

export default Security;
